import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import Preloader from 'components/Preloader';
import { Select, Title } from 'ui-library';
import LabeledValue from 'components/common/LabeledValue';

const ProposalAgentInformation = ({ datasource }) => {
    const { dfsClientId } = useParams();

    const {
        t,
        validation,
        generalAgencies = [],
        selectedGeneralAgency,
        setSelectedGeneralAgency,
        agentsList,
        selectedAgent,
        setSelectedAgent,
        handleSearchAgents,
        searchAgentsInProgress,
        isPreloadInProgress,
        selectedAgencyInfo,
        selectedAgentInfo,
    } = datasource({ dfsClientId });

    const generalAgenciesOptions = useMemo(() => [{ label: t('position.pleaseSelect'), value: '' }, ...(generalAgencies?.map(i => ({ label: i.name, value: i.id })) || [])], [generalAgencies]);
    const agentsListOptions = useMemo(() => [{ value: '', label: t('position.pleaseSelect') }, ...agentsList.map(i => ({ value: i.id, label: `${i.firstName} ${i.lastName}` }))], [agentsList]);

    return (
        <Preloader isLoading={isPreloadInProgress}>
            <div>
                <Title type={2} className="mb-40">{t('portfolio.createNewPortfolio.agentInformation.advisorInformation')}</Title>
                <div className="row">
                    <div className="col-md-4">
                        <dl className="DataList DataList--singleCol">
                            <Select
                                data-cy="agentInfo"
                                disabled={false}
                                options={agentsListOptions}
                                label={t('portfolio.createNewPortfolio.agentInformation.advisor')}
                                required
                                value={selectedAgent}
                                placeholder={t('position.pleaseSelect')}
                                onChange={(val) => setSelectedAgent(val)}
                                error={validation?.agent}
                                hasSearch
                                asyncSearch={handleSearchAgents}
                                searchInProgress={searchAgentsInProgress}
                            />
                            {selectedAgentInfo && (
                                <>
                                    {/* <Title type={2} className="mt-20">{t('portfolio.createNewPortfolio.agentInformation.advisorInformation')}</Title> */}
                                    <LabeledValue label={t('portfolio.createNewPortfolio.agentInformation.advisor.firstName')}>{selectedAgentInfo.firstName}</LabeledValue>
                                    <LabeledValue label={t('portfolio.createNewPortfolio.agentInformation.advisor.lastName')}>{selectedAgentInfo.lastName}</LabeledValue>
                                    <LabeledValue label={t('portfolio.createNewPortfolio.agentInformation.advisor.street')} >{selectedAgentInfo.streetAddress || '-'}</LabeledValue>
                                    <LabeledValue label={t('portfolio.createNewPortfolio.agentInformation.advisor.location')} >{`${selectedAgentInfo.postalCode || '-'} / ${selectedAgentInfo.city || '-'}`}</LabeledValue>
                                    <LabeledValue label={t('portfolio.createNewPortfolio.agentInformation.advisor.phone')} >{selectedAgentInfo.phoneNumber || '-'}</LabeledValue>
                                    <LabeledValue label={t('portfolio.createNewPortfolio.agentInformation.advisor.email')} >{selectedAgentInfo.email || '-'}</LabeledValue>
                                </>
                            )}
                        </dl>
                    </div>
                    <div className="col-md-6">

                        <dl className="DataList DataList--singleCol">
                            <Select
                                onChange={(val) => setSelectedGeneralAgency(val)}
                                label={t('portfolio.createNewPortfolio.agentInformation.generalAgency')}
                                placeholder={t('position.pleaseSelect')}
                                required
                                data-cy="generalAgency"
                                value={selectedGeneralAgency}
                                options={generalAgenciesOptions}
                                hasSearch
                                width={450}
                                error={validation?.generalAgency}
                            />
                            {selectedAgencyInfo && (
                                <>
                                    {/* <Title type={2} className="mt-20">{t('portfolio.createNewPortfolio.agentInformation.GeneralAgencyInfo')}</Title> */}
                                    <LabeledValue label={t('portfolio.createNewPortfolio.agentInformation.bank.name')}>{selectedAgencyInfo.name}</LabeledValue>
                                    <LabeledValue label={t('portfolio.createNewPortfolio.agentInformation.advisor.street')} >{selectedAgencyInfo.address}</LabeledValue>
                                    <LabeledValue label={t('portfolio.createNewPortfolio.agentInformation.advisor.location')} >{`${selectedAgencyInfo.zip} / ${selectedAgencyInfo.city}`}</LabeledValue>
                                    <LabeledValue label={t('portfolio.createNewPortfolio.agentInformation.advisor.phone')} >{selectedAgencyInfo.phone}</LabeledValue>
                                    <LabeledValue label={t('portfolio.createNewPortfolio.agentInformation.advisor.gaVstNumber')} >{selectedAgencyInfo.vstNumber}</LabeledValue>
                                </>
                            )}
                        </dl>
                    </div>
                </div>
            </div>
        </Preloader>
    );
};

export default ProposalAgentInformation;
